import React from "react";
import exterteamicon from "../../assets/Homepage/WhychooseusDesktop/ExpertTeam.png";
import HolisticApproachicon from "../../assets/Homepage/WhychooseusDesktop/HolisticApproach.png";
import SupportiveEnvironmenticon from "../../assets/Homepage/WhychooseusDesktop/SupportiveEnvironment.png";
import CustomizedTreatmenticon from "../../assets/Homepage/WhychooseusDesktop/CustomizedTreatment.png";
import AftercareSupporticon from "../../assets/Homepage/WhychooseusDesktop/AftercareSupport.png";
import ProvenSuccessRatesicon from "../../assets/Homepage/WhychooseusDesktop/ProvenSuccessRates.png";

const whyChooseUsData = [
  {
    icon: exterteamicon,
    title: "Expert Team",
    desc: "Our team of experienced professionals, including doctors, therapists, and counselors, provide personalized care and guidance.",
  },
  {
    icon: HolisticApproachicon,
    title: "Holistic Approach",
    desc: "We offer a comprehensive treatment plan that addresses physical, emotional, and psychological aspects of addiction.",
  },
  {
    icon: SupportiveEnvironmenticon,
    title: "Supportive Environment",
    desc: "Our center provides a safe, comfortable, and supportive environment for recovery.",
  },
  {
    icon: CustomizedTreatmenticon,
    title: "Customized Treatment",
    desc: "Our programs are tailored to meet individual needs and goals.",
  },
  {
    icon: AftercareSupporticon,
    title: "Aftercare Support",
    desc: "We offer ongoing support and resources to help maintain sobriety.",
  },
  {
    icon: ProvenSuccessRatesicon,
    title: "Proven Success Rates",
    desc: "Our center has a track record of successful recoveries.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="bg-[#2C3075]  md:px-[75px] py-12 sm:py-16 lg:py-20">
      {/* Changed container to go wider & reduce side padding */}
      <div className="max-w-[1400px] mx-auto px-2 sm:px-4 lg:px-6">
        {/* Main Heading */}
        <h2 className="font-garamond-subheading  text-white mb-8 sm:mb-10 lg:mb-12 text-center sm:text-left">
          Why choose us
        </h2>

        {/* Cards Grid */}
       {/* Cards Grid */}
<div className="
  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 
  gap-x-6 gap-y-8 
  justify-items-center sm:justify-items-stretch
">
  {whyChooseUsData.map((item, index) => (
    <div
      key={index}
      className="
        bg-white 
        rounded-xl 
        shadow-md 
        p-5 sm:p-6 
        flex flex-col 
        items-start 
        transition-transform 
        duration-300 
        hover:scale-105 
        group
        w-[342px] h-[224px]      /* Mobile */
        md:w-[380px] md:h-[294px] /* Desktop */
      "
    >
      {/* Icon Circle */}
      <div className="bg-[#FBB040] w-16 h-16 p-3 rounded-full mb-4 flex items-center justify-center transition-colors duration-300 group-hover:bg-[#2C3075]">
        <img
          src={item.icon}
          alt={item.title}
          className="w-6 h-6 object-contain transition-colors duration-300"
        />
      </div>

      {/* Card Title */}
      <h3
        className="font-generalsans-subheading font-semibold text-[#2C3075] mb-2"
        style={{ fontFamily: "General Sans, sans-serif" }}
      >
        {item.title}
      </h3>

      {/* Card Description */}
      <p
        className="font-generalsans-description text-[#696C9D] leading-relaxed"
        style={{ fontFamily: "General Sans, sans-serif" }}
      >
        {item.desc}
      </p>
    </div>
  ))}
</div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
